export default "__VITE_ASSET__CkefFd0K__"